import React, { useState } from 'react';

import AsyncTable from '../../generic/Table/AsyncTable';
import Titled from '../../layout/Titled';
import api from '../../REST/api';
import ExportAllMerchants from '../ExportAllMerchants';
import { listColumns } from '../merchant-columns';
import MerchantsBulkEditor from '../MerchantsBulkEditor';

function AsyncList() {
  const [selectedItems, setSelectedItems] = useState([]);
  const [tableFilters, setTableFilters] = useState({});

  return (
    <Titled
      title="Merchants"
      actions={[
        <MerchantsBulkEditor
          selectedItems={selectedItems}
          disabled={!selectedItems.length}
        />,
      ]}
    >
      <AsyncTable
        className="select-table"
        keyField="id"
        selectionName="merchants"
        storedName="MERCHANT_FILTERS"
        setSelectedItems={setSelectedItems}
        minRows={2}
        allowFilterView
        allowSelection
        columns={listColumns}
        allColumns={listColumns}
        queryFn={api.getZMSAMMerchants}
        setTableFilters={setTableFilters}
      >
        <ExportAllMerchants tableFilters={tableFilters} className="ml-3" />
      </AsyncTable>
    </Titled>
  );
}

export default AsyncList;
